// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"472":"488c6fdd","1485":"18694e62","2019":"8c270517","2864":"aa1ade10","5257":"574fc5dd","5496":"210b2c35","8147":"b92e2e14"}[chunkId] + ".css";
};